import { ApiClient } from '../apiClient';
import { PaginationDto } from '../../types/pagination';
import { WishlistEntry, WishlistSummaryItem } from '../../types/wishlist';

export class WishlistService {
  constructor(private apiClient: ApiClient) {}

  async getMyWishlist(page = 0, limit = 20): Promise<PaginationDto<WishlistEntry>> {
    return this.apiClient.get<PaginationDto<WishlistEntry>>('/wishlist', { page, limit });
  }

  async getSummary(): Promise<WishlistSummaryItem[]> {
    return this.apiClient.get<WishlistSummaryItem[]>('/wishlist/summary');
  }

  async addToWishlist(productId: string): Promise<WishlistEntry> {
    return this.apiClient.post<WishlistEntry>('/wishlist', { productId });
  }

  async removeById(id: string): Promise<void> {
    return this.apiClient.delete<void>(`/wishlist/${id}`);
  }

  async removeByProductId(productId: string): Promise<void> {
    return this.apiClient.delete<void>(`/wishlist/product/${productId}`);
  }
}
